import React from 'react'

const Bullet = () => {
    return (
        <span className="bullet2">
            
        </span>
    )
}

export default Bullet